<template>
  <div class="singleChart col-12 row text-center mx-0 mb-0 px-0">
    <div class="col-md-10 col-12">
      <chart
        :chartId="chartId"
        :chartName="chartName"
        :chartType="chartType"
        :chartData="chartData"
        :styleGroup="{ width: '100%', height: '250px' }"
        :reDraw="true"
      />
    </div>
    <div class="col-md-2 col-12 my-auto">
      <div
        v-for="(radioValue, key) in radioArray"
        class="form-check text-start"
      >
        <input
          class="form-check-input"
          type="radio"
          name="charts-radios"
          :id="'charts-radios-' + key"
          :value="key"
          :checked="key == selected"
          @change="selected = key"
        />
        <label class="form-check-label" :for="'charts-radios-' + key">
          {{ radioValue }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import chart from "@/components/chart.vue";
import { ref, watch } from "vue";
export default {
  components: {
    chart,
  },
  props: {
    chartArray: {
      type: Array,
      default: [],
    },
    radioArray: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    const chartId = ref("radioButtonChart");
    const chartName = ref();
    const chartType = ref();
    const chartData = ref();
    const selected = ref();

    const initRadioButtonChart = () => {
      if (!Array.isArray(props.chartArray)) {
        return;
      }
      if (props.chartArray[0] == undefined) {
        return;
      }
      if (props.chartArray[0].chartName != undefined) {
        chartName.value = props.chartArray[0].chartName;
      }
      if (props.chartArray[0].chartType != undefined) {
        chartType.value = props.chartArray[0].chartType;
      }
      if (props.chartArray[0].chartData != undefined) {
        chartData.value = props.chartArray[0].chartData;
      }
    };

    const changeChart = () => {
      console.log(props.chartArray);
      chartName.value = props.chartArray[selected.value].chartName;
      chartType.value = props.chartArray[selected.value].chartType;
      chartData.value = props.chartArray[selected.value].chartData;
    };

    initRadioButtonChart();

    //watch
    watch(selected, (newValue) => {
      console.log(newValue);
      changeChart();
    });

    watch(
      () => props.chartArray,
      () => {
        selected.value = 0;
        // chartId.value = ref(
        //   "radioButtonChart-" + Math.random() + "_" + selected.value
        // );
      },
      { deep: true }
    );

    return {
      selected,
      chartId,
      chartName,
      chartType,
      chartData,
      changeChart,
    };
  },
};
</script>

<style></style>
